import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid'

import './styles.css';
import api from '../../services/api';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100vh'
	},
	image: {
		backgroundImage: 'url(https://www.canaadoscarajas.pa.gov.br/novo/wp-content/uploads/2019/08/LETREIRO-TURISTICO.jpeg)',
		backgroundRepeat: 'no-repeat',
		backgroundColor:
			theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	paper: {
		margin: theme.spacing(8, 4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));



export default function ForgetPassword() {
	const classes = useStyles();
	const [email, setEmail] = useState('');
	const navigate = useNavigate();

	async function handleSubmit(e) {
		e.preventDefault();
		try {

			//Faz a requisição
			await api.post('/password/reset', {
				"email": email
			});

			navigate('/choice-new-password', {
				state: {
					email
				}
			});
		} catch (e) {
			toast.error('Houve uma falha ao tentar resetar sua senha')
		}

	}

	return (
		<Grid container component="main" className={classes.root}>
			<CssBaseline />
			<Grid item xs={false} sm={4} md={7} className={classes.image} />
			<Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
				<div className="forget-password-container">

					<Grid container alignItems="center">
						<CssBaseline />

						<div className={classes.paper}>
							<Avatar className={classes.avatar}>
								<LockOutlinedIcon />
							</Avatar>

							<Typography component="h1" variant="h5">
								Esqueci minha senha
							</Typography>

							<form className={classes.form} onSubmit={handleSubmit}>
								<TextField
									variant="outlined"
									margin="normal"
									required
									fullWidth
									label="Digite o e-mail utilizado na conta"
									autoFocus
									value={email}
									onChange={e => setEmail(e.target.value)}
								/>

								<div className="logar">
									<button type="submit" className="button">Continuar</button >
								</div>

								<Grid
									container
									alignItems='center'
									justifyContent='center'
								>
									<Grid item>
										<Link style={{ cursor: 'pointer' }} href='/'>
											Voltar
										</Link>
									</Grid>
								</Grid>

								<Grid container>
									<Grid item style={{ 'textAlign': 'left', 'marginTop': '10px' }}>
										<p>Problemas para realizar login? Entre em contato com o administrador
											do sistema através do e-mail <b>projetocanaaufpa@gmail.com</b>.</p>
									</Grid>
								</Grid>

							</form>
						</div>
					</Grid>
				</div>
			</Grid>
		</Grid>
	);
}